import { lazy, Suspense, useEffect } from "react";
import Seo from "../components/Seo";
import {
  PAGE_SEO,
  organizationSchema,
  webSiteSchema,
  localBusinessSchema,
} from "../lib/seo";
import { optimizeImageUrl } from "../lib/image-url";
import HomeCarousel from "../components/HomeCarousel";
import Stats from "../components/Stats";
import LazyWhenVisible from "../components/LazyWhenVisible";
import SectionPlaceholder from "../components/SectionPlaceholder";
import { trackHomeVisit } from "../lib/tracker";

const LCP_HERO_IMAGE = optimizeImageUrl(
  "https://images.unsplash.com/photo-1497366216548-37526070297c",
  { width: 1024, quality: 68 },
);

const ServicesShowcase = lazy(() => import("../components/ServicesShowcase"));
const HowWeWork = lazy(() => import("../components/HowWeWork"));
const FeaturedWork = lazy(() => import("../components/FeaturedWork"));
const ApproachComparison = lazy(() => import("../components/ApproachComparison"));
const TechStack = lazy(() => import("../components/TechStack"));
const IndustryMarquee = lazy(() => import("../components/IndustryMarquee"));
const CoreValues = lazy(() => import("../components/CoreValues"));
const WhyChoose = lazy(() => import("../components/WhyChoose"));
const Testimonials = lazy(() => import("../components/Testimonials"));
const ContactForm = lazy(() => import("../components/ContactForm"));

function BelowFold({ children, height = "400px" }) {
  return (
    <LazyWhenVisible minHeight={height} rootMargin="320px">
      <Suspense fallback={<SectionPlaceholder height={height} />}>{children}</Suspense>
    </LazyWhenVisible>
  );
}

export default function HomePage() {
  useEffect(() => {
    trackHomeVisit();
  }, []);

  const seo = PAGE_SEO.home;

  return (
    <div data-testid="home-page">
      <Seo
        title={seo.title}
        description={seo.description}
        path={seo.path}
        preloadImage={LCP_HERO_IMAGE}
        jsonLd={[organizationSchema(), webSiteSchema(), localBusinessSchema()]}
      />
      <HomeCarousel />
      <Stats />
      <BelowFold height="520px">
        <ServicesShowcase />
      </BelowFold>
      <BelowFold height="380px">
        <HowWeWork />
      </BelowFold>
      <BelowFold height="420px">
        <FeaturedWork />
      </BelowFold>
      <BelowFold height="360px">
        <ApproachComparison />
      </BelowFold>
      <BelowFold height="280px">
        <TechStack />
      </BelowFold>
      <BelowFold height="120px">
        <IndustryMarquee />
      </BelowFold>
      <BelowFold height="400px">
        <CoreValues />
      </BelowFold>
      <BelowFold height="360px">
        <WhyChoose />
      </BelowFold>
      <BelowFold height="320px">
        <Testimonials />
      </BelowFold>
      <BelowFold height="480px">
        <ContactForm />
      </BelowFold>
    </div>
  );
}
